import React from "react";

const BuildingsIcon = () => {
	return (
		<>
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width="18"
				height="18"
				viewBox="0 0 18 18"
				fill="none"
			>
				<path
					d="M1.125 15.1863H16.875"
					stroke="currentColor"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M10.1245 15.1863V2.81128C10.1245 2.66209 10.0652 2.51902 9.95976 2.41353C9.85427 2.30804 9.7112 2.24878 9.56201 2.24878H2.81201C2.66283 2.24878 2.51975 2.30804 2.41426 2.41353C2.30877 2.51902 2.24951 2.66209 2.24951 2.81128V15.1863"
					stroke="currentColor"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M15.7495 15.1863V7.31128C15.7495 7.1621 15.6902 7.01902 15.5848 6.91353C15.4793 6.80804 15.3362 6.74878 15.187 6.74878H10.1245"
					stroke="currentColor"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M4.49951 5.06128H6.74951"
					stroke="currentColor"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M5.62451 9.56128H7.87451"
					stroke="currentColor"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M4.49951 12.3738H6.74951"
					stroke="currentColor"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M12.3745 12.3738H13.4995"
					stroke="currentColor"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M12.3745 9.56128H13.4995"
					stroke="currentColor"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</svg>
		</>
	);
};
export default BuildingsIcon;
